import { defineComponent } from 'vue';
export default defineComponent({
  name: 'MyDepartment',
  components: {},
  setup: function setup(props, ctx) {
    return {};
  }
});